import React, { useEffect } from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Services } from './components/Services';
import { HowItWorks } from './components/HowItWorks';
import { UseCases } from './components/UseCases';
import { WhyMatters } from './components/WhyMatters';
import { Partnership } from './components/Partnership';
import { DemoTour } from './components/DemoTour';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    document.title = 'MUNISVerse | Immersive Virtual Property Tours Nigeria';
  }, []);
  return <div className="min-h-screen bg-zinc-950 text-zinc-50 selection:bg-white/20" data-id="element-0">
      <Nav data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <About data-id="element-4" />
        <Problem data-id="element-5" />
        <Solution data-id="element-6" />
        <Services data-id="element-7" />
        <HowItWorks data-id="element-8" />
        <UseCases data-id="element-9" />
        <WhyMatters data-id="element-10" />
        <Partnership data-id="element-11" />
        <DemoTour data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}